import EmailSender from "../components/setting/EmailSender/EmailSender";

const EmailSenderPage =()=>{
     
    return(
          <EmailSender/>
    )
}

export default EmailSenderPage;